const url = '/service-paid-by-options';
const Provider = 'servicePaidByOptions';
const dbModel = 'servicePaidByOptions';

export { url, Provider, dbModel };
